import { defineStore } from "pinia";
import {
  api,
  type Result,
  Success,
  watchRequest,
  type ResultOkRef,
} from "../api";
import {
  DistrictResponseSchema,
  type DistrictPayload,
} from "../schemas/district";
import { markRaw } from "vue";

class DistrictApi {
  private readonly url = "/district/";
  getDistricts(): ResultOkRef<Success<DistrictPayload[]>> {
    return watchRequest(this.url, DistrictResponseSchema.array());
  }

  createDistrict(
    payload: DistrictPayload[],
  ): Promise<Result<DistrictPayload[]>> {
    return api.post(this.url, DistrictResponseSchema.array(), payload);
  }

  updateDistrict(
    payload: DistrictPayload[],
  ): Promise<Result<DistrictPayload[]>> {
    return api.patch(this.url, DistrictResponseSchema.array(), payload);
  }
}

const store = defineStore("district", () => ({
  api: markRaw(new DistrictApi()),
}));

export function useDistrict() {
  return store().api;
}
